const logLevels = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
  };
  
  const currentLogLevel = logLevels.DEBUG; // Change this based on the environment
  
  const logger = {
    debug: (message, ...args) => {
      if (currentLogLevel <= logLevels.DEBUG) {
        console.debug(message, ...args);
      }
    },
    info: (message, ...args) => {
      if (currentLogLevel <= logLevels.INFO) {
        console.info(message, ...args);
      }
    },
    warn: (message, ...args) => {
      if (currentLogLevel <= logLevels.WARN) {
        console.warn(message, ...args);
      }
    },
    error: (message, ...args) => {
      if (currentLogLevel <= logLevels.ERROR) {
        console.error(message, ...args);
      }
    },
  };
  
  export default logger;